import { fabric } from 'fabric';

export const initCloneStampCanvases = ({ width, height }) => {
  const manipulationCanvas = new fabric.StaticCanvas('manipulation-canvas', {
    selection: false,
    width,
    height,
    enableRetinaScaling: false,
  });
  window.manipulationCanvas = manipulationCanvas;

  const drawingCanvas = new fabric.Canvas('drawing-canvas', {
    selection: false,
    width,
    height,
    enableRetinaScaling: false,
  });
  window.drawingCanvas = drawingCanvas;
};
